export default __webpack_public_path__ + "static/wave-billboard-desktop-6c5e0e318c2bf206b5cbcb3201df39ee.svg";